import React, { useContext, useEffect, useState } from "react";
import { Formik, useFormik } from "formik";
import * as Yup from "yup";
import { Logindetail } from "../context/Logindetail";
import moment from "moment/moment";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import {
  accountdetails_fun,
  getprofile_fun,
  update_fun,
} from "../api/Dashboardapi";
import {
  City_fun,
  Country_fun,
  GenderApi,
  State_fun,
} from "../api/Controllapi";
import { CameraFill, X } from "react-bootstrap-icons";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { format } from "date-fns";
import dayjs from "dayjs";
import { useRef } from "react";

const MyAccount = () => {
  const [file, setfile] = useState();
  const [gender, setgender] = useState([]);
  const [imag, setimag] = useState();
  const [spinner, setspinner] = useState(false);
  const [CountryData, setCountryData] = useState([]);
  const [StateData, setStateData] = useState([]);
  const [countryid, setcountryid] = useState();
  const [CityData, setCityData] = useState();
  const [aadharlist, setaadharlist] = useState([]);
  const [panlist, setpanlist] = useState([]);
  const [date, setdate] = useState();
  const [adharfile, setAdharfile] = useState([]);
  const [panfile, setpanfile] = useState([]);
  const [existingAadharDoc, setExistingAadharDoc] = useState([])
  const [existingPanDoc, setExistingPanDoc] = useState([])


  const router = useNavigate();

  const { detail_info, setdetail_info } = useContext(Logindetail);
  const today = dayjs().subtract(18, "years");

  const [initValue, setinitValue] = useState({
    // profile

    name: `${detail_info?.name ? detail_info?.name : ""}`,
    // father_name: `${detail_info?.father_name ? detail_info?.father_name : ""}`,
    phone_number: `${detail_info?.phone_number ? detail_info?.phone_number : ""
      }`,

    phone_number_code: `${detail_info?.phone_number_code ? detail_info?.phone_number_code : ""}`,
    email: `${detail_info?.email ? detail_info?.email : ""}`,
    date_of_birth: `${detail_info?.date_of_birth ? detail_info?.date_of_birth : ""
      }`,

    //added
    instagram: `${detail_info?.instagram ? detail_info?.instagram : ""}`,

    gender: `${detail_info?.gender ? detail_info?.gender : "female"}`,
    avatar: `${detail_info?.avatar ? detail_info?.avatar : ""}`,

    // addresss

    address_1: `${detail_info?.address_1 ? detail_info?.address_1 : ""}`,
    address_2: `${detail_info?.address_2 ? detail_info?.address_2 : ""}`,
    country: `${detail_info?.country ? detail_info?.country : ""}`,
    state: `${detail_info?.state ? detail_info?.state : ""}`,
    city: `${detail_info?.city ? detail_info?.city : ""}`,
    postal: `${detail_info?.postal ? detail_info?.postal : ""}`,

    // Kyc

    name_as_aadhar: `${detail_info?.name_as_aadhar ? detail_info?.name_as_aadhar : ""
      }`,
    aadhar_number: `${detail_info?.aadhar_number ? detail_info?.aadhar_number : ""
      }`,
    name_as_pan: `${detail_info?.name_as_pan ? detail_info?.name_as_pan : ""}`,
    pan_number: `${detail_info?.pan_number ? detail_info?.pan_number : ""}`,
    pan_documents: `${detail_info?.pan_documents ? detail_info?.pan_documents : ""
      }`,
    aadhar_documents: `${detail_info?.aadhar_documents ? detail_info?.aadhar_documents : ""
      }`,

    holder_name: `${detail_info?.account_detail?.holder_name
      ? detail_info?.account_detail?.holder_name
      : ""
      }`,
    account_number: `${detail_info?.account_detail?.account_number
      ? detail_info?.account_detail?.account_number
      : ""
      }`,
    confirm_account_number: `${detail_info?.account_detail?.account_number
      ? detail_info?.account_detail?.account_number
      : ""
      }`,
    ifsc: `${detail_info?.account_detail?.ifsc ? detail_info?.account_detail?.ifsc : ""
      }`,
    account_type: `${detail_info?.account_detail?.account_type
      ? detail_info?.account_detail?.account_type
      : "Savings"
      }`,
    bank_name: `${detail_info?.account_detail?.bank_name
      ? detail_info?.account_detail?.bank_name
      : ""
      }`,
    branch: `${detail_info?.account_detail?.branch
      ? detail_info?.account_detail?.branch
      : ""
      }`,
    gpay: `${detail_info?.account_detail?.gpay ? detail_info?.account_detail?.gpay : ""
      }`,
    upi: `${detail_info?.account_detail?.upi ? detail_info?.account_detail?.upi : ""
      }`,
  });

  const updateschema = Yup.object().shape({
    name: Yup.string()
      .required("Enter Full Name")
      .matches(/^[a-zA-Z ]+$/, "Only letters and spaces allowed")
      .test(
        "not-only-spaces",
        "Name cannot be only spaces",
        (value) => value && value.trim().length > 0),

    // father_name: Yup.string()
    //   .required("Enter Mother Name")
    //   .matches(/^[a-zA-Z ]+$/, "Only letters and spaces allowed")
    //   .test(
    //     "not-only-spaces",
    //     "Name cannot be only spaces",
    //     (value) => value && value.trim().length > 0),
    // .required("Enter mother name")
    // .matches(/^[a-zA-Z ]*$/, "Invalid name"),

    phone_number: Yup.string()
      .min(5, "Phone Number Minimum 5 digits")

      .required("Enter your Phone Number")
      .matches(/^[0-9]+$/, "Invalid  Phone Number"),

    email: Yup.string()
      .email("Invalid Email")
      .required("Enter Your Email")
      .matches(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-z\-0-9]+\.)+[a-z]{2,}))$/,
        "Invalid Email"
      )
      .test("Invalid Email", (value) => {
        return value === value.toLowerCase();
      }),

    date_of_birth: Yup.string(),

    //added
    instagram: Yup.string(),

    gender: Yup.string(),

    avatar: Yup.mixed(),

    address_1: Yup.string().required("Enter Your Address"),

    address_2: Yup.string(),

    country: Yup.string(),

    state: Yup.string(),

    city: Yup.string(),

    postal: Yup.string(),

    name_as_aadhar: Yup.string()
      .required("Enter Name as per Aadhar")
      .matches(/^[a-zA-Z ]+$/, "Only letters and spaces allowed")
      .test(
        "not-only-spaces",
        "Name cannot be only spaces",
        (value) => value && value.trim().length > 0
      ),

    //   name_as_aadhar: Yup.string()
    // .required("Enter Name as per Aadhar")
    // .matches(/^[a-zA-Z ]+$/, "Only letters and spaces allowed")
    // .test(
    //   "not-only-spaces",
    //   "Name cannot be only spaces",
    //   (value) => value && value.trim().length > 0
    // ),


    aadhar_number: Yup.string()
      .required("Enter Aadhar Number")
      .min(12, " Aadhar number Minimum 12 digits")
      .matches(/^[0-9]+$/, "Invalid  Aadhar number"),

    name_as_pan: Yup.string()
      .required("Enter Name as pan card")
      .matches(/^[a-zA-Z ]+$/, "Only letters and spaces allowed")
      .test(
        "not-only-spaces",
        "Name cannot be only spaces",
        (value) => value && value.trim().length > 0
      ),
    // .required("Enter Name as per PAN")
    // .matches(/^[a-zA-Z]+$/, "Only letters allowed, no spaces"),

    pan_number: Yup.string()
      .required("Enter PAN number")
      .matches(
        /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
        "Pan number must contain 10 characters, including five uppercase letter,  four number, and last one uppercase letter"
      ),

    // pan_documents: Yup.mixed()
    //   .required("upload pan documents"),
    pan_documents: Yup.mixed()
      .test('pan-documents', 'Upload pan documents', function (value) {
        const hasNewFiles = panfile && panfile.length > 0;
        const hasExistingFiles = existingPanDoc && existingPanDoc.length > 0;
        return hasNewFiles || hasExistingFiles;
      }),

    aadhar_documents: Yup.mixed()
      .test('aadhar-documents', 'Upload aadhar documents', function (value) {
        const hasNewFiles = adharfile && adharfile.length > 0;
        const hasExistingFiles = existingAadharDoc && existingAadharDoc.length > 0;
        return hasNewFiles || hasExistingFiles;
      }),
    // aadhar_documents: Yup.mixed(),
    // .required("upload aadhar documents"),

    holder_name: Yup.string()
      .required("Enter Account Holder Name")
      .matches(/^[a-zA-Z ]*$/, "Invalid name"),

    account_number: Yup.string()
      .required("Enter Account Number")
      .matches(/^[0-9]+$/, "Invalid  Account Number")
      .min(6, "Account number minimum 6 digits"),

    confirm_account_number: Yup.string()
      .required("Enter Confirm Account Number")
      .matches(/^[0-9]+$/, "Invalid  Account Number")
      .min(6, "Account number minimum 6 digits")
      .oneOf(
        [Yup.ref("account_number"), null],
        "Account Number must be a Same"
      ),

    ifsc: Yup.string()
      .required("Enter IFSC Code")
      .matches(/^[A-Z0-9]+$/, "Invalid IFSC Code")
      .min(11, " Ifsc code Must be 11 digits"),

    account_type: Yup.string().required("Enter Account Type"),

    bank_name: Yup.string()
      .required("Enter Bank Name")
      .matches(/^[a-zA-Z]+$/, "Only letters allowed, no spaces"),

    branch: Yup.string()
      .required("Enter Branch Name")
      .matches(/^[a-zA-Z ]+$/, "Only letters and spaces allowed")
      .test(
        "not-only-spaces",
        "Name cannot be only spaces",
        (value) => value && value.trim().length > 0
      ),

    gpay: Yup.string()
      .required("Enter Gpay Number")
      .min(10, "Gpay Number Minimum 10 digits")
      .max(10, "Gpay Number Maximum 10 digits")
      .matches(/^[0-9]+$/, "Invalid  Account Number"),

    upi: Yup.string()
      .required("Enter UPI ID")
      .matches(/^[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{2,64}/, "Invalid UPI ID"),
  });

  // function handlechange(e) {
  //   setimag(e.target.files[0])
  //   setfile(URL.createObjectURL(e.target.files[0]))
  // }

  // function handlechange(e) {

  //   if (e.target.files[0]?.type === 'image/jpeg') {

  //     if (e.target.files[0]?.size > 2 * 1024 * 1024 || e.target.files[0]?.size <= 0) {
  //       toast.error('File Size Max 2MB')
  //     }
  //     else {
  //       setfile(URL.createObjectURL(e.target.files[0]));
  //       setimag(e.target.files[0])
  //     }

  //   }
  //   else {
  //     toast.error('Only Upload jpeg format')
  //   }

  // }

  //   function handlechange(e) {
  //   const file = e.target.files[0];

  //   if (file?.type === 'image/jpeg') {
  //     setfile(URL.createObjectURL(file));
  //     setimag(file);
  //   } else {
  //     toast.error('Only Upload JPEG format');
  //   }
  // }

  function handlechange(e) {
    const file = e.target.files[0];

    if (file) {
      setfile(URL.createObjectURL(file));
      setimag(file);
    }
  }

  // const handleaadhar = (e) => {

  //   const data = Object.values(e.target.files)

  //   for (var i = 0; i < data?.length; i++) {

  //     if (data[i]?.type === 'image/jpg' || data[i]?.type === 'image/jpeg' || data[i]?.type === 'image/png') {

  //       if (data[i]?.size > 2 * 1024 * 1024 || e.target.files[0]?.size <= 0) {
  //         toast.error('File Size Max 2MB')
  //       }
  //       else {

  //         setAdharfile([...adharfile, data[i]]);
  //       }
  //     }
  //     else {
  //       toast.error('Check image format')
  //     }
  //   }

  // }

  const allowedTypes = [
    "image/jpg",
    "image/jpeg",
    "image/png",
    "application/pdf",
    "image/gif",
    "application/msword", // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
  ];

  const handleaadhar = (e) => {
    const data = Array.from(e.target.files); // safer way to convert FileList

    const validFiles = [];
    const invalidFiles = [];

    for (let i = 0; i < data.length; i++) {
      const file = data[i];

      if (allowedTypes.includes(file?.type)) {
        validFiles.push(file);
      } else {
        invalidFiles.push(file.name);
      }
    }

    if (validFiles.length) {
      setAdharfile((prev) => [...prev, ...validFiles]);
    }

    if (invalidFiles.length) {
      toast.error(`Unsupported format: ${invalidFiles.join(", ")}`);
    }
  };


  // const handleaadhar = (e) => {
  //   const data = Object.values(e.target.files);

  //   for (let i = 0; i < data.length; i++) {
  //     const file = data[i];

  //     if (
  //       file?.type === "image/jpg" ||
  //       file?.type === "image/jpeg" ||
  //       file?.type === "image/png"
  //     ) {
  //       setAdharfile((prev) => [...prev, file]);
  //     } else {
  //       toast.error("Check image format");
  //     }
  //   }
  // };

  const cancelimage = (value) => {
    setAdharfile((p) => p?.filter((r) => r != value));
  };


  const cancelAadharPreview = (value) => {
    setaadharlist((p) => p?.filter((r) => r != value))
  }

  const cancelPanPreview = (value) => {
    setpanlist((p) => p?.filter((r) => r != value))
  }

  //added




  const removeExistingAadhar = (file) => {
    setExistingAadharDoc((f) => f?.filter((fil) => fil != file))
  }

  const removeExistingPan = (file) => {
    setExistingPanDoc((f) => f?.filter((fil) => fil != file))
  }



  const FilePreview = ({ file, onRemove, type = "new" }) => {
    const isImage = file.type
      ? file.type.startsWith("image/")
      : typeof file === "string" && !file.toLowerCase().endsWith(".pdf");

    const isPDF = file.type
      ? file.type === "application/pdf"
      : typeof file === "string" && file.toLowerCase().endsWith(".pdf");

    const fileUrl = file.type ? URL.createObjectURL(file) : file;
    const fileName =
      file.name || (typeof file === "string" ? file.split("/").pop() : "Document");

    const handleOpenInNewTab = () => {
      window.open(fileUrl, "_blank", "noopener,noreferrer");
    };

    return (
      <div
        className="position-relative m-2 p-2 border rounded bg-light"
        style={{ width: "120px", cursor: "pointer" }}
        onClick={handleOpenInNewTab}
        title="Click to open in new tab"
      >
        <div className="text-center">
          {isImage ? (
            <img
              src={fileUrl}
              className="img-fluid"
              style={{ maxWidth: "80px", maxHeight: "80px", objectFit: "cover" }}
              // alt={type === "existing" ? "Existing document" : "New document"}
              onError={(e) => {
                e.target.src = "/assets/iocns/ifsc code.png";
              }}
            />
          ) : isPDF ? (
            <img
              src="/assets/iocns/pdf.png"
              alt="PDF document"
              className="img-fluid"
              style={{ width: "50px", height: "50px" }}
            />
          ) : (
            <img
              src="/assets/icons/ifsc code  .png"
              alt="Unknown file"
              className="img-fluid"
              style={{ width: "50px", height: "50px" }}
            />
          )}
          <div className="small text-truncate mt-1" style={{ width: "100px" }}>
            {fileName}
          </div>
          {/* <div
          className={`badge ${type === "existing" ? "bg-info" : "bg-success"}`}
          style={{ fontSize: "8px" }}
        >
          {type.toUpperCase()}
        </div> */}
        </div>

        <button
          type="button"
          className="position-absolute bg-danger text-white border-0 rounded-circle d-flex align-items-center justify-content-center"
          style={{
            width: "20px",
            height: "20px",
            top: "-8px",
            right: "-8px",
            cursor: "pointer",
            fontSize: "12px",
          }}
          onClick={(e) => {
            e.stopPropagation();
            onRemove(file);
          }}
          title={`Remove ${type} document`}
        >
          <X size={12} />
        </button>
      </div>
    );
  };
  // const handlepan = (e) => {

  //   const data = Object.values(e.target.files)

  //   for (var i = 0; i < data?.length; i++) {

  //     if (data[i]?.type === 'image/jpg' || data[i]?.type === 'image/jpeg' || data[i]?.type === 'image/png') {

  //       if (data[i]?.size > 2 * 1024 * 1024 || e.target.files[0]?.size <= 0) {
  //         toast.error('File Size Max 2MB')
  //       }
  //       else {

  //         setpanfile([...panfile, data[i]]);
  //       }
  //     }
  //     else {
  //       toast.error('Check image format')
  //     }
  //   }

  // }


  useEffect(() => {
    if (detail_info) {
      // Handle Aadhar documents
      if (detail_info.aadhar_documents_image) {
        if (Array.isArray(detail_info.aadhar_documents_image)) {
          setExistingAadharDoc(detail_info.aadhar_documents_image);
        } else if (typeof detail_info.aadhar_documents_image === 'string') {
          try {
            const parsedDocs = JSON.parse(detail_info.aadhar_documents_image);
            setExistingAadharDoc(Array.isArray(parsedDocs) ? parsedDocs : [parsedDocs]);
          } catch {
            setExistingAadharDoc([detail_info.aadhar_documents_image]);
          }
        }
      }



      // Handle Pan documents
      if (detail_info.pan_documents_image) {
        if (Array.isArray(detail_info.pan_documents_image)) {
          setExistingPanDoc(detail_info.pan_documents_image);
        } else if (typeof detail_info.pan_documents_image === 'string') {
          try {
            const parsedDocs = JSON.parse(detail_info.pan_documents_image);
            setExistingPanDoc(Array.isArray(parsedDocs) ? parsedDocs : [parsedDocs]);
          } catch {
            setExistingPanDoc([detail_info.pan_documents_image]);
          }
        }
      }
    }




  }, [])



  const handlepan = (e) => {
    const data = Array.from(e.target.files);

    const validFiles = [];
    const invalidFiles = [];

    for (let i = 0; i < data.length; i++) {
      const file = data[i];

      if (allowedTypes.includes(file?.type)) {
        validFiles.push(file);
      } else {
        invalidFiles.push(file.name);
      }
    }

    if (validFiles.length) {
      setpanfile((prev) => [...prev, ...validFiles]);
    }

    if (invalidFiles.length) {
      toast.error(`Unsupported format: ${invalidFiles.join(", ")}`);
    }
  };
  // const handlepan = (e) => {
  //   const data = Object.values(e.target.files);

  //   for (let i = 0; i < data.length; i++) {
  //     const file = data[i];

  //     if (
  //       file?.type === "image/jpg" ||
  //       file?.type === "image/jpeg" ||
  //       file?.type === "image/png"
  //     ) {
  //       setpanfile((prev) => [...prev, file]);
  //     } else {
  //       toast.error("Check image format");
  //     }
  //   }
  // };

  const cancelimage2 = (value) => {
    setpanfile(panfile?.filter((e) => e != value));
  };

  const Formrik = useFormik({
    initialValues: initValue,
    enableReinitialize: true,
    validationSchema: updateschema,
    onSubmit: async (value, { setErrors, setStatus, resetForm }) => {
      // console.log("✅ Formik onSubmit called with:", value);
      // console.log(value?.date_of_birth);
      setspinner(true);
      const DOB = moment(date).format("YYYY-MM-DD");
      const formdata = new FormData();
      formdata.append("name", value.name);
      // formdata.append("father_name", value.father_name);
      formdata.append("phone_number", value.phone_number);
      formdata.append("phone_number_code", value.phone_number_code);

      formdata.append("email", value.email);
      formdata.append("date_of_birth", DOB);
      //added
      formdata.append("instagram", value.instagram);
      formdata.append("gender", value.gender);
      formdata.append("address_1", value.address_1);
      formdata.append("address_2", value.address_2);
      formdata.append("country", value.country);
      formdata.append("state", value.state);
      formdata.append("city", value.city);
      formdata.append("postal", value.postal);
      formdata.append("avatar", imag);
      formdata.append("name_as_aadhar", value.name_as_aadhar);
      formdata.append("aadhar_number", value.aadhar_number);
      formdata.append("name_as_pan", value.name_as_pan);
      formdata.append("pan_number", value.pan_number);
      // adharfile?.map((data, i) => {
      //   formdata.append(`aadhar_documents[${i}]`, data);
      // });
      if (adharfile.length > 0) {
        adharfile.forEach((file, index) => {
          formdata.append(`aadhar_documents[${index}]`, file);
        });
      } else if (existingAadharDoc.length > 0) {
        // Keep existing files
        formdata.append("keep_existing_aadhar", "true");
      }
      if (panfile.length > 0) {
        panfile.forEach((file, index) => {
          formdata.append(`pan_documents[${index}]`, file);
        });
      } else if (existingPanDoc.length > 0) {
        // Keep existing files
        formdata.append("keep_existing_pan", "true");
      }
      // panfile?.map((data, i) => {
      //   formdata.append(`pan_documents[${i}]`, data);
      // });
      formdata.append("holder_name", value.holder_name);
      formdata.append("account_number", value.account_number);
      formdata.append("confirm_account_number", value.confirm_account_number);
      formdata.append("ifsc", value.ifsc);
      formdata.append("account_type", value.account_type);
      formdata.append("bank_name", value.bank_name);
      formdata.append("branch", value.branch);
      formdata.append("gpay", value.gpay);
      formdata.append("upi", value.upi);

      // update_fun(formdata)
      update_fun(formdata)

        .then((res) => {
          setspinner(false);
          toast.success(res?.message);
          handlegetprofile();
        })
        .catch((err) => {
          setspinner(false);
        });
    },
  });

  useEffect(() => {
    genderapi();
    getcountry();
    setfile(detail_info?.avatar ?? "");
    handlegetprofile();
  }, []);

  useEffect(() => {
    if (Formrik.submitCount > 0 && Object.keys(Formrik.errors).length > 0) {
      const firstError = Object.values(Formrik.errors)[0];
      toast.error(firstError);
    }
  }, [Formrik.submitCount]);

  const genderapi = async () => {
    try {
      GenderApi()
        .then((res) => {
          setgender(res?.data);
        })
        .catch((err) => {
        });
    } catch (err) {
    }
  };

  const getcountry = async () => {
    Country_fun()
      .then((res) => {
        setCountryData(res?.data);
      })
      .catch((err) => {
      });
  };

  // useEffect(() => {


  //   const value = Formrik.getFieldProps("country").value;
  //   const value2 = Formrik.getFieldProps("state").value;


  //   if (value) {
  //     getstate(value);
  //   }

  //   if (value2) {
  //     getcity(value, value2);
  //   }

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [Formrik.getFieldProps("country").value]);

  // const getstate = (id) => {
  //   Formrik.setFieldValue("country", id);
  //   setcountryid(id);
  //   State_fun(id)
  //     .then((res) => {
  //       setStateData(res?.data);
  //       // getcity(countryid,id)
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  // const getcity = (con, id) => {
  //   City_fun(con, id)
  //     .then((res) => {
  //       setCityData(res?.data);
  //       console.log("city datat.....", CityData)
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };
  useEffect(() => {
    const { country, state, city } = Formrik.values;

    if (country) {
      State_fun(country)
        .then(res => {
          setStateData(res.data);

          // If there's a saved state
          if (state) {
            City_fun(country, state)
              .then(res => setCityData(res.data))
              .catch(console.error);
          }
        })
        .catch(console.error);
    }
  }, []);

  const prevCountryRef = useRef(Formrik.values.country);

  useEffect(() => {
    const country = Formrik.values.country;

    if (prevCountryRef.current !== country) {
      Formrik.setFieldValue("state", "");
      Formrik.setFieldValue("city", "");
      if (country) {
        getstate(country);
        setCityData([]);
      } else {
        setStateData([]);
        setCityData([]);
      }
    }

    prevCountryRef.current = country;
  }, [Formrik.values.country]);


  const prevStateRef = useRef(Formrik.values.state);

  useEffect(() => {
    const country = Formrik.values.country;
    const state = Formrik.values.state;

    if (prevStateRef.current !== state) {
      Formrik.setFieldValue("city", "");
      if (country && state) {
        getcity(country, state);
      } else {
        setCityData([]);
      }
    }

    prevStateRef.current = state;
  }, [Formrik.values.state]);

  const getstate = (countryId) => {
    setcountryid(countryId);
    State_fun(countryId)
      .then((res) => setStateData(res.data))
      .catch(console.error);
  };

  // Fetch cities for country & state
  const getcity = (countryId, stateId) => {
    City_fun(countryId, stateId)
      .then((res) => setCityData(res.data))
      .catch(console.error);
  };

  const handlegetprofile = () => {
    getprofile_fun()
      .then((res) => {
        localStorage.setItem("green_login", JSON.stringify(res?.data));
        setdetail_info(res?.data);
        setfile(res?.data?.avatar);
      })
      .catch((err) => {
        setspinner(false);
      });
  };

  // useEffect(() => {
  //   genderapi();
  //   getcountry();
  //   setfile(detail_info?.avatar ?? "");
  //   handlegetprofile();
  // }, []);

  useEffect(() => {
    const aadharlist1 = Formrik.getFieldProps("aadhar_documents_image").value;
    setaadharlist(aadharlist1 ? aadharlist1.split(",") : "");

    const panlist1 = Formrik.getFieldProps("pan_documents_image").value;
    setpanlist(panlist1 ? panlist1.split(",") : "");
  }, []);


  // console.log(aadharlist)
  // console.log(panlist, "..........")
  return (
    <>
      {/* <section className='breadcamp'>
        <div className='container'>
          <div className='d-flex gap-2'>
            <h4 className='mb-0' style={{ cursor: "pointer" }}><span onClick={() => { router('/') }} >Home</span>{`>> My Account`}</h4>
          </div>
        </div>
      </section> */}

      <section className="pt-3">
        <div className="container">
          <div className="myaccont_layout">
            <div className="myaccount-title text-center">
              <h2>My Account</h2>
            </div>
            <div className="myaccount-info mt-5">
              <form onSubmit={Formrik.handleSubmit}>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="myac-basicdetail">
                      <div className="bd-head pb-3">
                        <h4>Basic Details</h4>
                      </div>
                      <div className="bd-form border">
                        <div className="profice-pic text-center position-relative">
                          <img
                            src={file ? file : "/assets/images/user.jfif"}
                            id="uploadimg"
                            className="img-fluid"
                            alt=""
                          />
                          <input
                            type="file"
                            id="my_file"
                            className="d-none"
                            accept="image/*"
                            onChange={handlechange}
                          />
                          <div
                            className=" profile-came position-absolute"
                            onClick={() => {
                              document.getElementById("my_file").click();
                            }}
                          >
                            <CameraFill />
                          </div>
                        </div>
                        <div className="row p-md-4 p-sm-0">
                          <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                            <label> Full Name</label>
                            <input
                              type="text"
                              className="form-control"
                              id="inputname"
                              placeholder=" Name"
                              {...Formrik.getFieldProps("name")}
                            />
                          </div>
                          {/* <div className="form-group col-md-6  col-sm-6 col-6 login-text">
                            <label>Mother Name</label>
                            <input
                              type="text"
                              className="form-control"
                              id="inputfathername"
                              placeholder="Mother Name"
                              {...Formrik.getFieldProps("father_name")}
                            />
                          </div> */}
                          <div className="form-group col-md-6  col-sm-6 col-6 login-text">
                            <label>Email</label>
                            <input
                              type="Email"
                              className="form-control"
                              id="inputemail"
                              placeholder="Email"
                              {...Formrik.getFieldProps("email")}
                            />
                          </div>
                          <div className="form-group col-md-6  col-sm-6 col-6 login-text">
                            <label>Phone</label>
                            <input
                              type="number"
                              disabled
                              className="form-control"
                              id="inputPhone"
                              placeholder="Phone"
                              {...Formrik.getFieldProps("phone_number")}
                            />

                            {/* <div className="input-group">
                              <span className="input-group-text disabled " id="countryCode">+{Formrik.values.phone_number_code || "+91"}</span>
                              <input
                                type="number"
                                disabled
                                className="form-control"
                                id="inputPhone"
                                placeholder="Phone"
                                aria-describedby="countryCode"
                                {...Formrik.getFieldProps("phone_number")}
                              />
                            </div> */}




                          </div>
                          <div className="form-group col-md-6  col-sm-6 col-6 login-text">
                            <label>Date of Birth</label>
                            {/* <input type="date" className="form-control" id="inputemail2" placeholder="D-O-B" {...Formrik.getFieldProps("date_of_birth")} pattern="\d{2}-\d{2}-\d{4}" /> */}
                            <div className="react-date">
                              {/* <DatePicker
                                selected={date}
                                dateFormat="dd/MM/yyyy"
                                minDate={new Date(moment().subtract(100, "years"))}
                                maxDate={new Date(moment().subtract(18, "years"))}
                                peekNextMonth
                                showMonthDropdown
                                placeholderText="DD-MM-YYYY"
                                showYearDropdown
                                dropdownMode="select"
                                onChange={(date) => { setdate(date); Formrik.setFieldValue('date_of_birth', moment(date).format('YYYY-MM-DD')) }}

                              /> */}
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer
                                  components={["DatePicker", "DatePicker"]}
                                >
                                  {/* <DatePicker
                                    maxDate={today}
                                    format="DD-MM-YYYY"
                                    onChange={(newValue) => { setdate(format(newValue, 'yyyy-MM-dd')) }}
                                    defaultValue={detail_info?.date_of_birth ? dayjs(detail_info?.date_of_birth) : ''}
                                    sx={{
                                      backgroundColor: "#b7b2b221",
                                      "& .MuiOutlinedInput-notchedOutline": {
                                        border: "none"
                                      },
                                      "&.Mui-focused": {
                                        "& .MuiOutlinedInput-notchedOutline": {
                                          border: "none"
                                        }
                                      }


                                    }}
                                    slotProps={{
                                      field: {
                                        readOnly: true
                                      }
                                    }}

                                  /> */}
                                  <DatePicker
                                    maxDate={today}
                                    format="DD-MM-YYYY"
                                    onChange={(newValue) => {
                                      setdate(
                                        dayjs(newValue).format("YYYY-MM-DD")
                                      );
                                    }}
                                    defaultValue={
                                      detail_info?.date_of_birth
                                        ? dayjs(detail_info?.date_of_birth)
                                        : ""
                                    }
                                    sx={{
                                      backgroundColor: "#b7b2b221",
                                      "& .MuiOutlinedInput-notchedOutline": {
                                        border: "none",
                                      },
                                      "&.Mui-focused": {
                                        "& .MuiOutlinedInput-notchedOutline": {
                                          border: "none",
                                        },
                                      },
                                    }}
                                    slotProps={{
                                      field: {
                                        readOnly: true,
                                      },
                                    }}
                                  />
                                </DemoContainer>
                              </LocalizationProvider>
                            </div>
                          </div>

                          {/* //added */}
                          <div className="form-group col-md-6  col-sm-6 col-6 login-text">
                            <label>Instagram (Use Link)</label>
                            <input
                              type="text"
                              className="form-control"
                              id="inputinstagram"
                              placeholder="Instagram"
                              {...Formrik.getFieldProps("instagram")}
                            />
                          </div>


                          {/* // */}



                          <div className="form-group col-md-6  col-sm-6 col-6 login-text">
                            <label>Gender</label>
                            <select
                              className="form-select"
                              id="inputGroupSelect01"
                              {...Formrik.getFieldProps("gender")}
                            >
                              {/* {
                                gender ? gender.map((r, i) => {
                                  return (
                                    <option value={r.id} key={i}>{r.name}</option>
                                  )
                                }) : ""
                              } */}
                              <option value="" selected disabled>
                                Select
                              </option>
                              <option value="male">Male</option>
                              <option value="female">Female</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="myac-withdraw mt-5">
                      <div className="bd-head pb-3">
                        <h4>Withdrawal Method</h4>
                      </div>
                      <div className="bd-form border">
                        {/* <div className="row">
                          <div className="form-group col-md-6 col-sm-6 col-6 login-text" >
                            <label>Name as Aadhar Card</label>
                            <input type="text" className="form-control" id="inputaddress7" placeholder="Name as Aadhar Card" />
                          </div>
                          <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                            <label>Aadhar Number</label>
                            <input type="text" className="form-control" id="inputaddress8" placeholder="Aadhar Number" />
                          </div>
                          <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                            <label>Name As Pan Card</label>
                            <input type="text" className="form-control" id="inputaddress9" placeholder="Name As Pan Card" />
                          </div>
                          <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                            <label>Pan Number</label>
                            <input type="text" className="form-control" id="inputaddress10" placeholder="Pan Number" />
                          </div>
                          <div className="form-group col-md-12 col-12  mb-3 login-text">
                            <label>Upload Documents *(PNG,JPG,JPEG)</label>
                            <input className="form-control" id="inputGroupFile03" type="file" />
                          </div>
                        </div> */}
                        <div className="row">
                          <div className="col-md-12 col-sm-12 col-12   form-group login-text">
                            <label className="col-form-label">
                              Account Holder Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="recipient-name"
                              placeholder="Account Holder Name"
                              {...Formrik.getFieldProps("holder_name")}
                            />
                          </div>

                          <div className="col-md-6 col-sm-6 col-6 form-group login-text">
                            <label className="col-form-label mb-acnum">
                              Account Number
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              id="recipient-name2"
                              placeholder="Account Number"
                              {...Formrik.getFieldProps("account_number")}
                            />
                          </div>
                          <div className="col-md-6 col-sm-6 col-6  form-group login-text">
                            <label className="col-form-label">
                              Confirm Account Number
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              id="recipient-name1"
                              placeholder="Confirm Account Number"
                              {...Formrik.getFieldProps(
                                "confirm_account_number"
                              )}
                            />
                          </div>
                          <div className="col-md-6 col-sm-6 col-6  form-group login-text">
                            <label className="col-form-label">Bank Name</label>
                            <input
                              type="text"
                              className="form-control"
                              id="recipient-name3"
                              placeholder="Bank Name"
                              {...Formrik.getFieldProps("bank_name")}
                            />
                          </div>

                          <div className="col-md-6 col-sm-6 col-6  form-group login-text">
                            <label className="col-form-label">
                              Branch Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="recipient-name3"
                              placeholder="Branch Name"
                              {...Formrik.getFieldProps("branch")}
                            />
                          </div>
                          <div className="col-md-6 col-sm-6 col-6  form-group login-text">
                            <label className="col-form-label">IFSC Code</label>
                            <input
                              type="text"
                              className="form-control"
                              id="recipient-name3"
                              placeholder="IFSC Code"
                              {...Formrik.getFieldProps("ifsc")}
                            />
                          </div>
                          <div className="col-md-6 col-sm-6 col-6  form-group login-text">
                            <label className="col-form-label">
                              Account Type
                            </label>
                            <select
                              className="form-select"
                              aria-label="addbankname"
                              {...Formrik.getFieldProps("account_type")}
                            >
                              <option value="" selected disabled>
                                Select
                              </option>
                              <option value="Savings">Savings</option>
                              <option value="Current">Current</option>
                            </select>
                          </div>
                          <div className="border my-2"></div>
                          <div className="col-md-6 col-sm-6 col-6  form-group login-text">
                            <label className="col-form-label">
                              Gpay Number
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              id="recipient-name3"
                              placeholder="Gpay Number"
                              {...Formrik.getFieldProps("gpay")}
                            />
                          </div>

                          <div className="col-md-6 col-sm-6 col-6  form-group login-text">
                            <label className="col-form-label">UPI ID</label>
                            <input
                              type="text"
                              className="form-control"
                              id="recipient-name3"
                              placeholder="UPI ID"
                              {...Formrik.getFieldProps("upi")}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="myac-addrdetail mt-5 mt-lg-0">
                      <div className="bd-head pb-3">
                        <h4>Address Details</h4>
                      </div>
                      <div className="bd-form border ">
                        <div className="row">
                          <div className="form-group col-md-12 login-text">
                            <label>Address Line 1</label>{" "}
                            <input
                              type="text"
                              className="form-control"
                              id="inputaddress"
                              placeholder="Address Line 1"
                              {...Formrik.getFieldProps("address_1")}
                            />
                          </div>
                          <div className="form-group col-md-12 login-text">
                            <label>Address Line 2</label>
                            <input
                              type="text"
                              className="form-control"
                              id="inputaddress2"
                              placeholder="Address Line 2"
                              {...Formrik.getFieldProps("address_2")}
                            />
                          </div>

                          <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                            <label>Country</label>
                            <select
                              className="form-select"
                              id="inputGroupSelect00"
                              {...Formrik.getFieldProps("country")}
                            >
                              <option value={""}
                                disabled>
                                Select
                              </option>
                              {CountryData?.map((r, index) => {
                                return (
                                  <option value={r?.id} key={index}> {r?.name} </option>
                                );
                              })}
                            </select>
                          </div>

                          <div className="form-group col-md-6 col-sm-6 col-6 login-text ">
                            <label>State</label>
                            <select
                              className="form-select"
                              id="inputGroupSelect02"
                              {...Formrik.getFieldProps("state")}

                            >
                              <option value={""} disabled>
                                Select
                              </option>
                              {StateData?.map((r, index) => {
                                return (
                                  <option value={r?.id} key={index}>{r?.state}</option>
                                );
                              })}
                            </select>
                          </div>

                          <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                            <label>City</label>
                            <select
                              className="form-select"
                              id="inputGroupSelect03"
                              {...Formrik.getFieldProps("city")}

                            >
                              <option value={""} disabled>
                                Select
                              </option>
                              {CityData?.map((r, index) => {
                                return <option value={r?.id} key={index} >{r?.city}</option>;
                              })}
                            </select>
                          </div>

                          <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                            <label>Postal code</label>
                            <input
                              type="number"
                              className="form-control"
                              id="inputaddress2"
                              placeholder="Postal code"
                              {...Formrik.getFieldProps("postal")}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="myac-kyc mt-5">
                      <div className="bd-head pb-3 ">
                        <h4>KYC Info</h4>
                      </div>
                      <div className="bd-form border">
                        <div className="row">
                          <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                            <label>Name as Aadhar Card</label>
                            <input
                              type="text"
                              className="form-control"
                              id="inputaddress3"
                              placeholder="Name as Aadhar Card"
                              {...Formrik.getFieldProps("name_as_aadhar")}
                            />
                          </div>

                          <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                            <label>Aadhar Number</label>
                            <input
                              type="number"
                              maxLength={12}
                              className="form-control"
                              id="inputaddress4"
                              placeholder="Aadhar Number"
                              {...Formrik.getFieldProps("aadhar_number")}
                            />
                          </div>

                          <div className="form-group mb-3 col-md-12 col-12 login-text">
                            <label>
                              Upload Aadhar Documents{" "}
                              <span className="doc-format">
                                *(PNG,JPG,JPEG)
                              </span>
                            </label>
                            <div className="upload-docs">
                              <button
                                className="btn"
                                type="button"
                                onClick={() => {
                                  document.getElementById("aadharfile").click();
                                }}
                              >
                                {" "}
                                <span>
                                  <img src="\assets\iocns\upload.png" alt="" />
                                </span>{" "}
                                Image Upload
                              </button>
                            </div>
                            <input
                              className="form-control d-none"
                              id="aadharfile"
                              type="file"
                              accept=".png, .jpg, .jpeg, .pdf, .gif, .doc, .docx"
                              // accept="image/jpg, image/jpeg, image/png"
                              multiple="multiple"
                              onChange={handleaadhar}
                            />


                            {/* Existing Aadhar Documents from API */}
                            {existingAadharDoc.length > 0 && (
                              <div className="mt-3">
                                <h6 className="mb-2">Existing Aadhar Documents:</h6>
                                <div className="d-flex flex-wrap">
                                  {existingAadharDoc.map((doc, index) => (
                                    <FilePreview
                                      key={`existing-aadhar-${index}`}
                                      file={doc}
                                      onRemove={removeExistingAadhar}
                                      type="existing"
                                    />
                                  ))}
                                </div>
                              </div>
                            )}

                            {/* <div className="selected-file d-flex flex-wrap login-text">

                                {aadharlist && aadharlist.length>0 ? (
                                  aadharlist?.map((data, index) => {
                                const baseUrl = "https://admin.greenheapgold.com/public/assets/media/aadhar_documents/";

                                return (
                                  <div className="position-relative me-2 mb-2" key={index}>
                                    <img
                                      src={`${baseUrl}${data}`}
                                      className="img-fluid docimg"
                                      alt={`aadhar-${index}`}
                                    />
                                    <div
                                      className="diselect position-absolute"
                                      onClick={() => cancelAadharPreview(data)}
                                     
                                    >
                                      <X />
                                    </div>
                                  </div>
                                );
                              })):(
                                <p className="text-muted">No Aadhar documents uploaded yet</p>
                                )}
                             
                            </div> */}
                            {aadharlist.length > 0 && <h6 className="mt-2 mb-2">Uploaded Aadhar Documents:</h6>}
                            <div className="selected-file d-flex flex-wrap login-text">
                              {aadharlist.length > 0 &&
                                aadharlist.map((url, i) => {
                                  // Guess file type from URL extension (simple check)
                                  const lowerUrl = url.toLowerCase();

                                  const isImage = lowerUrl.endsWith(".png") || lowerUrl.endsWith(".jpg") || lowerUrl.endsWith(".jpeg") || lowerUrl.endsWith(".gif");
                                  const isPdf = lowerUrl.endsWith(".pdf");
                                  const isExcel = lowerUrl.endsWith(".xls") || lowerUrl.endsWith(".xlsx");

                                  let previewSrc;

                                  if (isImage) {
                                    previewSrc = url; // Use URL directly
                                  } else if (isPdf) {
                                    previewSrc = "/assets/iocns/pdf.png";
                                  } else if (isExcel) {
                                    previewSrc = "/assets/iocns/excel.png";
                                  } else {
                                    previewSrc = "/assets/iocns/pdf.png"; // fallback icon
                                  }

                                  return (
                                    <div className="position-relative" key={i}>
                                      <img
                                        src={previewSrc}
                                        className="img-fluid docimg"
                                        alt={`file preview ${i}`}
                                      />
                                      <div
                                        className="diselect position-absolute"
                                        onClick={() => {
                                          cancelAadharPreview(url);
                                        }}
                                      >
                                        <X />
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>

                            {/* <div className="selected-file d-flex flex-wrap login-text">
                              {adharfile.length > 0 &&
                                adharfile.map((url, i) => {
                                  // Guess file type from URL extension (simple check)
                                 

                                  const isImage = url.endsWith(".png") || url.endsWith(".jpg") || url.endsWith(".jpeg") || lowerUrl.endsWith(".gif");
                                  const isPdf = url.endsWith(".pdf");
                                  const isExcel = url.endsWith(".xls") || url.endsWith(".xlsx");

                                  let previewSrc;

                                  if (isImage) {
                                    previewSrc = url; // Use URL directly
                                  } else if (isPdf) {
                                    previewSrc = "/assets/iocns/pdf.png";
                                  } else if (isExcel) {
                                    previewSrc = "/assets/iocns/excel.png";
                                  } else {
                                    previewSrc = "/assets/iocns/pdf.png"; // fallback icon
                                  }

                                  return (
                                    <div className="position-relative" key={i}>
                                      <img
                                        src={previewSrc}
                                        className="img-fluid docimg"
                                        alt={`file preview ${i}`}
                                      />
                                      <div
                                        className="diselect position-absolute"
                                        onClick={() => {
                                          cancelimage(url);
                                        }}
                                      >
                                        <X />
                                      </div>
                                    </div>
                                  );
                                })}
                            </div> */}

                            <div className="selected-file d-flex flex-wrap login-text">
                              {adharfile?.map((file, i) => {
                                const fileType = file.type;
                                const isImage = fileType.startsWith("image/");
                                const isPdf = fileType === "application/pdf";
                                const isExcel =
                                  fileType ===
                                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                                  fileType === "application/vnd.ms-excel";

                                let previewSrc;

                                if (isImage) {
                                  previewSrc = URL.createObjectURL(file);
                                } else if (isPdf) {
                                  previewSrc = "/assets/iocns/pdf.png";
                                } else if (isExcel) {
                                  previewSrc = "/assets/iocns/excel.png";
                                } else {
                                  previewSrc = "/assets/iocns/pdf.png";
                                }

                                return (
                                  <div className="position-relative" key={i}>
                                    <img
                                      src={previewSrc}
                                      className="img-fluid docimg"
                                      alt={file.name}
                                    />
                                    <div
                                      className="diselect position-absolute"
                                      onClick={() => {
                                        cancelimage(file);
                                      }}
                                    >
                                      <X />
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>

                          <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                            <label>Name as Pan Card</label>
                            <input
                              type="text"
                              className="form-control"
                              id="inputaddress5"
                              placeholder="Name as Pan Card"
                              {...Formrik.getFieldProps("name_as_pan")}
                            />
                          </div>

                          <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                            <label>Pan Number</label>
                            <input
                              type="text"
                              className="form-control"
                              id="inputaddress6"
                              placeholder="Pan Number"
                              {...Formrik.getFieldProps("pan_number")}
                            />
                          </div>

                          <div className="form-group mb-3 col-md-12 col-12 login-text">
                            <label>
                              Upload Pan Documents{" "}
                              <span className="doc-format">
                                *(PNG,JPG,JPEG)
                              </span>
                            </label>
                            <div className="upload-docs">
                              <button
                                className="btn"
                                type="button"
                                onClick={() => {
                                  document.getElementById("panfile").click();
                                }}
                              >
                                {" "}
                                <span>
                                  <img src="\assets\iocns\upload.png" alt="" />
                                </span>{" "}
                                Image Upload
                              </button>
                            </div>
                            <input
                              className="form-control d-none"
                              id="panfile"
                              // accept="image/jpg, image/jpeg, image/png"
                              // accept=".png, .jpg, .jpeg, .pdf, .gif, .doc, .docx"
                              // multiple="multiple"
                              multiple
                              accept=".png, .jpg, .jpeg, .pdf, .gif, .doc, .docx"
                              type="file"
                              onChange={handlepan}
                            />



                            {existingPanDoc.length > 0 && (
                              <div className="mt-3">
                                <h6 className="mb-2">Existing Pan Documents:</h6>
                                <div className="d-flex flex-wrap">
                                  {existingPanDoc.map((doc, index) => (
                                    <FilePreview
                                      key={`existing-aadhar-${index}`}
                                      file={doc}
                                      onRemove={removeExistingPan}
                                      type="existing"
                                    />
                                  ))}
                                </div>
                              </div>
                            )}


                            {/* <div className="selected-file d-flex flex-wrap login-text">

                                {panlist && panlist.length>0 ? (
                                  panlist?.map((data, index) => {
                                const baseUrl = "https://admin.greenheapgold.com/public/assets/media/pan_documents/";

                                return (
                                  <div className="position-relative me-2 mb-2" key={index}>
                                    <img
                                      src={`${baseUrl}${data}`}
                                      className="img-fluid docimg"
                                      alt={`pan-${index}`}
                                    />
                                    <div
                                      className="diselect position-absolute"
                                      onClick={() => cancelPanPreview(data)}
                                     
                                    >
                                      <X />
                                    </div>
                                  </div>
                                );
                              })):(
                                <p className="text-muted">No pan documents uploaded yet</p>
                                )}
                             
                            </div> */}
                            {panlist.length > 0 && <h6 className="mt-2 mb-2">Uploaded pan Documents:</h6>}
                            <div className="selected-file d-flex flex-wrap login-text">
                              {panlist.length > 0 &&
                                panlist.map((url, i) => {
                                  // Guess file type from URL extension (simple check)
                                  const lowerUrl = url.toLowerCase();

                                  const isImage = lowerUrl.endsWith(".png") || lowerUrl.endsWith(".jpg") || lowerUrl.endsWith(".jpeg") || lowerUrl.endsWith(".gif");
                                  const isPdf = lowerUrl.endsWith(".pdf");
                                  const isExcel = lowerUrl.endsWith(".xls") || lowerUrl.endsWith(".xlsx");

                                  let previewSrc;

                                  if (isImage) {
                                    previewSrc = url;
                                  } else if (isPdf) {
                                    previewSrc = "/assets/iocns/pdf.png";
                                  } else if (isExcel) {
                                    previewSrc = "/assets/iocns/excel.png";
                                  } else {
                                    previewSrc = "/assets/iocns/pdf.png"; // fallback icon
                                  }

                                  return (
                                    <div className="position-relative" key={i}>
                                      <img
                                        src={previewSrc}
                                        className="img-fluid docimg"
                                        alt={`file preview ${i}`}
                                      />
                                      <div
                                        className="diselect position-absolute"
                                        onClick={() => {
                                          cancelPanPreview(url);
                                        }}
                                      >
                                        <X />
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>






                            <div className="selected-file d-flex flex-wrap login-text">
                              {panfile?.map((file, i) => {
                                const fileType = file.type;
                                const isImage = fileType.startsWith("image/");
                                const isPdf = fileType === "application/pdf";
                                const isExcel =
                                  fileType ===
                                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                                  fileType === "application/vnd.ms-excel";

                                let previewSrc;

                                if (isImage) {
                                  previewSrc = URL.createObjectURL(file);
                                } else if (isPdf) {
                                  previewSrc = "/assets/iocns/pdf.png";
                                } else if (isExcel) {
                                  previewSrc = "/assets/iocns/excel.png";
                                } else {
                                  previewSrc = "/assets/iocns/pdf.png";
                                }

                                return (
                                  <div className="position-relative" key={i}>
                                    <img
                                      src={previewSrc}
                                      className="img-fluid docimg"
                                      alt={file.name}
                                    />
                                    <div
                                      className="diselect position-absolute"
                                      onClick={() => {
                                        cancelimage(file);
                                      }}
                                    >
                                      <X />
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="myac-submit submit mt-sm-5 mt-3">
                  <button className="text-white" type="submit">
                    {spinner ? (
                      <span
                        className="spinner-border spinner-border-sm "
                        role="status"
                      ></span>
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default MyAccount;